export default [
    {
        text: 'Name',
        value: 'name',
        order: 0,
        sortable: true,
        hidable: false,
        hidden: false,
    },

    {
        text: 'Created',
        value: 'createDate',
        order: 6,
        hidable: true,
        hidden: true,
    },

    {
        text: 'Actions',
        value: 'actions',
        align: 'right',
        sortable: false,
        order: 1,
        hidable: true,
        hidden: false,
        width: '92px',
    },
];
